import React from 'react';
import { clsx } from 'clsx';
import LoadingSpinner from './LoadingSpinner';
import { ButtonProps } from '@/types';

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  type = 'button',
  className,
  onClick,
  ...props
}) => {
  const base =
    'inline-flex items-center justify-center font-semibold rounded-xl transition-all duration-150 ' +
    'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-app ' +
    'disabled:opacity-40 disabled:cursor-not-allowed active:scale-[0.97]';

  const variants = {
    primary:
      'bg-accent text-accent-ink hover:bg-accent/85 focus:ring-accent ' +
      'shadow-[var(--glow-accent)] hover:shadow-[var(--glow-accent-hover)]',
    secondary:
      'bg-subtle text-ink hover:bg-elevated focus:ring-accent/40',
    success:
      'bg-emerald-600 text-white hover:bg-emerald-500 focus:ring-emerald-500',
    danger:
      'bg-red-600 text-white hover:bg-red-500 focus:ring-red-500',
    outline:
      'border border-line bg-transparent text-ink-muted ' +
      'hover:bg-subtle hover:text-ink hover:border-ink-faint focus:ring-accent/40',
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
  };

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={clsx(base, variants[variant], sizes[size], className)}
      {...props}
    >
      {loading && <LoadingSpinner size="sm" className="mr-2 text-current" />}
      {children}
    </button>
  );
};

export default Button;
